import React, { useState } from 'react'

const sections = [
  {
    key: 'licitatii',
    title: 'Licitatii sau achizitii publice',
    content: (
      <>
        <div>
          <span className="text-custom-gray font-montserrat text-[18px]">Fax: </span>
          <span className="text-custom-gray font-montserrat text-[18px]">0344 802 044</span>
        </div>
        <div>
          <span className="text-custom-gray font-montserrat text-[18px]">Email: </span>
          <span className="text-custom-gray font-montserrat text-[18px]">
            <a href="mailto:licitatii@magazialucostica.ro" className="text-custom-gray hover:underline">
              licitatii@magazialucostica.ro
            </a>
          </span>
        </div>
      </>
    ),
  },
  {
    key: 'sugestii',
    title: 'Reclamatii si Sugestii',
    content: (
      <>
        <div>
          <span className="text-custom-gray font-montserrat text-[18px]">Fax: </span>
          <span className="text-custom-gray font-montserrat text-[18px]">0344 802 044</span>
        </div>
        <div>
          <span className="text-custom-gray font-montserrat text-[18px]">Email: </span>
          <span className="text-custom-gray font-montserrat text-[18px]">
            <a href="mailto:reclamatii@magazialucostica.ro" className="text-custom-gray hover:underline">
              reclamatii@magazialucostica.ro
            </a>
          </span>
        </div>
      </>
    ),
  },
  {
    key: 'consiliere',
    title: 'Consiliere gratuita interna',
    content: (
      <>
        <div>
          <span className="text-custom-gray font-montserrat text-[18px]">Mobil: </span>
          <span className="text-custom-gray font-montserrat text-[18px]">
            <a href="tel:0371.710.071" className="text-custom-gray hover:underline">
              0371.710.071
            </a>
          </span>
        </div>
        <div>
          <span className="text-custom-gray font-montserrat text-[18px]">Formular: </span>
          <span className="text-custom-gray font-montserrat text-[18px]">
            Puteti utiliza formularul de contact selectand subiectul Consiliere, iar in maxim 24 de ore urmeaza a va contacta un reprezentant Keiron Logistics SRL
          </span>
        </div>
      </>
    ),
  },
]

export const AdditionalContactInfo = () => {
  const [open, setOpen] = useState<string | null>(null)

  return (
    <div className="additional-contact-info">
      <div className="additional-contact-info__container">
        <h3 className="hidden xl:block text-custom-gray font-montserrat text-[23px] font-bold leading-0 text-center mb-[48px]">
          Alte date de contact
        </h3>
        <div className="flex flex-col gap-0">
          {sections.map((section) => {
            const isOpen = open === section.key
            return (
              <div
                key={section.key}
                className={`border border-contact-gray bg-contact-bg transition-all duration-200 ${isOpen ? 'shadow-contact-shadow mt-[28px] mb-[28px] pb-[40px]' : ''}`}
              >
                <button
                  className={`w-full flex items-center justify-between px-5 py-3 focus:outline-none ${isOpen ? 'font-bold text-accent-green' : 'font-bold text-custom-gray'}`}
                  onClick={() => setOpen(isOpen ? null : section.key)}
                  type="button"
                  aria-expanded={isOpen}
                >
                  <span className={`text-[20px] font-montserrat ${isOpen ? 'text-accent-green' : ''}`}>{section.title}</span>
                  <span className="text-[32px] font-montserrat">{isOpen ? '-' : '+'}</span>
                </button>
                {isOpen && (
                  <div className="px-8 pt-0">
                    {section.content}
                  </div>
                )}
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}